export default __webpack_public_path__ + "static/media/undraw_profile_1.c2807abf.svg";